import { useQuery, QueryHookOptions } from '@apollo/client';
import type { OrganizationRateLimitsHQ } from './__generated__/OrganizationRateLimitsHQ';
import ORGANIZATION_RATE_LIMITS from './OrganizationRateLimits.hq.graphql';
export { default } from './FreeAnnouncementRateLimit';

export function useRateLimitedOrganizations(
  options: QueryHookOptions<OrganizationRateLimitsHQ> = {}
) {
  return useQuery<OrganizationRateLimitsHQ>(ORGANIZATION_RATE_LIMITS, {
    context: { hq: true },
    ...options,
  });
}

export function useIsFreeAnnouncementRateLimited() {
  const { data } = useRateLimitedOrganizations();

  const isRateLimited = data?.organizationRateLimits?.some(
    (limit) => limit.rateLimitedResource === 'freeAnnouncementSends'
  );

  return !!isRateLimited;
}
